"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAnalytics = void 0;
const providers_1 = require("../providers");
function useAnalytics(segmentation = {}) {
    const analytics = (0, providers_1.useAnalyticsService)();
    const log = (eventNameString, additionalSegmentation = {}) => {
        analytics.log(eventNameString, Object.assign(Object.assign({}, segmentation), additionalSegmentation));
    };
    return {
        log,
    };
}
exports.useAnalytics = useAnalytics;
